// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip-IkWoX"};